import AppEnvironment from '../../components/enums/appEnvironment.enum';
import { AppEnvironmentStore } from './appEnvironment.store.types';

export const selectIsInStoreEnvironment = (state: AppEnvironmentStore) =>
  state.appEnvironment === AppEnvironment.STORE;

export const selectIsInBrandEnvironment = (state: AppEnvironmentStore) =>
  state.appEnvironment === AppEnvironment.BRAND;
